import { Injectable } from '@angular/core';
import { Constant } from "../constant";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subscription, Subject, Observable } from 'rxjs';
import { SessionStorageService } from 'ngx-webstorage';
import { Dispatcher, StoreResource, StoreSourceInfos, StoreThirdAppId } from 'src/app/state';

@Injectable({ providedIn: 'root' })
export class DataService {
  populateData$ = new Subject();
  isLoad: boolean = false;


  public token: string = localStorage.getItem(Constant.key_local_token);

  public currentLang: string = localStorage.getItem(Constant.key_local_language) ? localStorage.getItem(Constant.key_local_language) : Constant.default_language;

  public listLanguage: Array<any> = [];

  public fundAssetTypes: Array<any> = [];

  public countries: Array<any> = [];

  public phonePostalCodes: Array<any> = [];

  public agents: Array<any> = [];

  public fundSchemes: Array<any> = [];

  public issuerTypes: Array<any> = [];

  public moneyTransferSyntax: Array<any> = [];

  public relationalOperators: Array<any> = [];

  public fundTypes: Array<any> = [];

  public moneyTypes: Array<any> = [];

  public banks: Array<any> = [];

  public socialTypes: Array<any> = [];

  public formulas: Array<any> = [];

  public interestRate: Array<any> = [];

  public provinces: Array<any> = [];

  public placeOfIssueIds: Array<any> = [];

  public idTypes: Array<any> = [];

  public assetAllocations: Array<any> = [];

  public investmentStrategies: Array<any> = [];

  public productReportPeriodicals: Array<any> = [];

  public paymentPeriodTypes: Array<any> = [];

  public daysOfWeek: Array<any> = [];

  public riskLevels: Array<any> = [];

  public bondPeriodTypes: Array<any> = [];

  public bondRemainPeriods: Array<any> = [];

  public bondPeriodAdjustedTypes: Array<any> = [];

  public subDomainOwners: Array<any> = [];

  public supportInfo: Array<any> = [];

  public markets: Array<any> = [];

  public resetWallet: boolean = false;

  public isLoading: boolean = true;

  public isSetData: boolean = false;

  public id: any = null;

  public second: any = null;

  public optionSearch: any = [];

  public sourceInfos: any = [];

  public dataCMS: any = localStorage.getItem(Constant.key_local_cms) ? JSON.parse(localStorage.getItem(Constant.key_local_cms)) : null;

  public dataState = new Subject<any>();

  public thirdApps: any = [];


  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private dispatcher: Dispatcher,
    private sessionStorageService: SessionStorageService
  ) {
  }
  setData(data) {
    this.isSetData = true;
    Object.keys(data).forEach((key) => {
      if (this[key] !== undefined) {
        this[key] = data[key]; //JSON.parse(JSON.stringify(data[key])) ;
      }
    })
    this.interestRate = data.reinvestmentInterests || data.interestRate;
    this.fundAssetTypes = data.fundAssetTypes;
    if (this.daysOfWeek[0] && this.daysOfWeek[0].id != 0) {
      this.daysOfWeek.unshift({
        id: 0,
        name: 'Thứ Hai đến Thứ Sáu'
      })
    };
    this.dispatcher.fire(new StoreResource(data));
  }
  getFull() {
    return this;
  }
  subData() {
    return new Promise((resolve, reject) => {
      let interval = setInterval(() => {
        if (this.isSetData) {
          clearInterval(interval);
          resolve(this.getFull());
        }
      }, 200)
    })
  }
  getState(): Observable<any> {
    return this.dataState.asObservable();
  }
  public getDataCommon() {
    this.isLoad = true;
    return new Promise<any>((resolve, reject) => {
      this.http.get(environment.urlBackEnd + Constant.api_common)
        .subscribe((res: any) => {
          this.isLoad = false;
          if (res.status === Constant.success_code) {
            sessionStorage.setItem(Constant.key_local_common_data, JSON.stringify(res.data));
            this.dataState.next(true);
            const subDomainOwner = ((res.data || {}).subDomainOwners || []).find((item) => {
              let hostname = location.hostname;
              hostname.replace('www.', '');
              return item.subDomain.includes(hostname);
            }) || {};
            this.sessionStorageService.store('subDomainOwners', subDomainOwner);
            this.setData(res.data);

            this.thirdApps = ((res.data || {}).thirdApps.data || []);
            this.dispatcher.fire(new StoreThirdAppId(this.thirdApps));

            resolve(true);
          }
        })
    })
  }
  public getSourcesInfo() {
    this.http.post(environment.urlBackEnd + '/agents/get-sources', {})
      .subscribe((res: any) => {
        this.sourceInfos = (res.data || []).map((item, index) => {
          item.id = index + 1;
          return item;
        });
        this.dispatcher.fire(new StoreSourceInfos(this.sourceInfos));
      })
  }

}
